import React from 'react';
import PersonalInformationTeaser from 'components/PersonalInformationTeaser';
import { Loader } from 'components';
import { useSelect } from 'hooks';

const ContainerPersonalInformationTeaser = () => {

  const loading = useSelect('loading.isLoading', { type: 'auth.getProfile' });
  const profile = useSelect('auth.profile');
  const user = useSelect('auth.user');

  if(loading){
    return <Loader.Table />
  }

  return (
    <PersonalInformationTeaser profile={profile} user={user}/>
  )
}

export default ContainerPersonalInformationTeaser